import getToken, { getUser } from '../../packages/api';

const isUserResponse = (user) => user.response;

const isStatusFourHundredOne = (user) => user.response.status === 401;

const tryFetchingUser = async (login) => {
  const user = await getUser();
  if (!user.response) {
    login(user);
  }
}

const fetchUser = async (code, login) => {
  const user = await getUser();
  if (isUserResponse(user)) {
    if (isStatusFourHundredOne(user)) {
      console.log('Token needs refreshing !');
      const token = await getToken(code);
      console.log(token);
      if (token) await getToken(token.refresh_token);
    }
  }
  if (!user.response) {
    login(user);
  }
};

const fetchUserToken = async (code, login) => {
  if (code) {
    await getToken(code);
    fetchUser(code, login);
  }
};

export {tryFetchingUser, fetchUserToken}
export default fetchUserToken;
